import { Controller } from "@hotwired/stimulus";

// Previews a newly chosen POS product/brand image before the form is saved: swaps the picked file into
// the preview <img> and hides the empty state. The upload itself still happens on form submit (Nexus
// scales and stores it); this is purely the local preview.
export default class extends Controller {
  static targets = ["input", "image", "placeholder"];

  preview() {
    const file = this.inputTarget.files[0];
    if (!file) return;

    // Release any object URL from a previous pick before creating a new one.
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
    this.objectUrl = URL.createObjectURL(file);

    this.imageTarget.src = this.objectUrl;
    this.imageTarget.classList.remove("hidden");
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden");
  }

  disconnect() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
  }
}
